module.exports = __webpack_public_path__ + "static/media/pred.89228f56.png";